import BaseModel from './BaseModel';
import ReviewMember from './ReviewMember';
import Reference from './Reference';
import moment from 'moment';
import {
  RelevanceAssessment,
  ScreeningOutcomeResolution,
} from '@/enums';

export default class ScreeningOutcome extends BaseModel {
  constructor(data = {}) {
    super(ScreeningOutcome, data);
    this.id = data.id;
    this.optimisticId = data.optimisticId ?? null;
    this.outcome = data.outcome;
    this.resolution = data.resolution;
    this.resolvedBy = data.resolvedBy
      ? new ReviewMember(data.resolvedBy)
      : null;
    this.reference = data.reference
      ? new Reference(data.reference)
      : null;
    this.preventRestore = data.preventRestore;
    this.createdAt = data.createdAt ? moment(data.createdAt) : null;
    this.updatedAt = data.updatedAt ? moment(data.updatedAt) : null;
  }

  creationData() {
    return {
      id: this.id,
      outcome: this.outcome,
      resolution: this.resolution,
      reference: this.reference.id,
    };
  }

  isOptimistic() {
    return !!this.optimisticId;
  }

  isRelevant() {
    return this.outcome === RelevanceAssessment.RELEVANT;
  }

  isNotSure() {
    return this.outcome === RelevanceAssessment.NOT_SURE;
  }

  isNotRelevant() {
    return this.outcome === RelevanceAssessment.NOT_RELEVANT;
  }

  isConsensus() {
    return (
      this.resolution === ScreeningOutcomeResolution.UNANIMOUS_VOTE
    );
  }

  isPreScreened() {
    return (
      this.resolution === ScreeningOutcomeResolution.PRE_SCREENED
    );
  }

  isSuggested() {
    return [
      ScreeningOutcomeResolution.SUGGESTED_STOP,
      ScreeningOutcomeResolution.USER_INITIATED_STOP,
    ].includes(this.resolution);
  }

  isConflictResolution() {
    return (
      this.resolution ===
      ScreeningOutcomeResolution.CONFLICT_RESOLUTION
    );
  }

  isManualUpdate() {
    return (
      this.resolution === ScreeningOutcomeResolution.UPDATED_OUTCOME
    );
  }
}
